import { Typography } from "@mui/material";

export default function StatusMessage({ message }) {
  if (!message) return null;

  const isPositive =
    message.includes("verify") || message.includes("sent");

  return (
    <Typography
      variant="body2"
      sx={{
        mt: 1,
        textAlign: "center",
        fontWeight: 500,
        color: isPositive ? "primary.main" : "error.main",
        opacity: 1,
        transition: "opacity 0.3s ease",
        fontSize: { xs: "0.8rem", sm: "0.9rem" },
      }}
    >
      {message}
    </Typography>
  );
}
